import React, { useState } from 'react';
import styles from './CareRespiteDateModal.module.scss';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store';
import { closeModal } from '../../../store/slices/uiSlice';
import { setStartFromJuly, resetQuiz } from '../../../store/slices/quizSlice';
import { setPreventedCaregiverField, resetFormData } from '../../../store/slices/formDataSlice';
import { Button } from '../../ui';

// Icons
import RobotIcon from '../../../assets/icons/robbot.svg';
import VectorIcon from '../../../assets/icons/vectorBottom.svg';
import RadioChecked from '../../../assets/icons/radioChecked.svg';
import RadioUnchecked from '../../../assets/icons/radioUnchecked.svg';

const dateOptions = [
  'Antrag für Verhinderungspflege BIS zum 30. Juni 2025',
  'Antrag für Verhinderungspflege AB dem 01. Juli 2025',
];

const CareRespiteDateModal: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState<string>('');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleDateSelect = (date: string) => {
    setSelectedDate(date);
  };

  const handleBack = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      navigate('/');
    } else {
      navigate('/profile');
    }
    dispatch(closeModal());
  };

  const handleConfirm = () => {
    // Reset quiz and form data for fresh start, but KEEP the reimbursementRef
    // The ref was created when the user started the flow and is needed for file uploads
    dispatch(resetQuiz());
    dispatch(resetFormData());
    
    const isAfterJuly = selectedDate === dateOptions[1];
    dispatch(setStartFromJuly(isAfterJuly));
    
    // When starting from July, clear the carePeriod field (legacy app behavior)
    // This question is not applicable for forms starting from July 2025
    if (isAfterJuly) {
      dispatch(setPreventedCaregiverField({ field: 'carePeriod', value: '' }));
    }
    
    dispatch(closeModal());
  };

  return (
    <section className={styles.careRespiteDateModal}>
      <div className={styles.message}>
        {/* Robot with speech bubble */}
        <div className={styles.robbot}>
          <div className={styles.messageRobot}>
            <img src={VectorIcon} alt="" className={styles.vectorIcon} />
            <p>
              Hinweis: Mit dem<span>&nbsp;01. Juli 2025&nbsp;</span>sind neue
              Regelungen für die Verhinderungspflege in Kraft getreten. Wenn Sie
              Verhinderungspflege für einen Zeitraum beantragen möchten, der sich
              über beide Zeitabschnitte erstreckt, stellen Sie bitte zwei separate
              Anträge.
            </p>
          </div>
          <img src={RobotIcon} alt="FLEXX-i" className={styles.robotImage} />
        </div>

        {/* Date selection */}
        <div className={styles.selectDate}>
          <p>Wann war die Verhinderungspflege?</p>
          <div className={styles.options}>
            {dateOptions.map((date, index) => (
              <div
                key={index}
                className={styles.option}
                onClick={() => handleDateSelect(date)}
              >
                <img
                  src={selectedDate === date ? RadioChecked : RadioUnchecked}
                  alt=""
                />
                <p>{date}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Action buttons */}
        <div className={styles.submit}>
          <Button variant="outline" onClick={handleBack}>
            Abbrechen
          </Button>
          <Button variant="primary" onClick={handleConfirm} disabled={!selectedDate}>
            Weiter
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CareRespiteDateModal;
